export default __webpack_public_path__ + "static/media/2hands.e2f90202.jpg";